import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./reducers/index";
import axiosReduxMiddleware from "./axiosReduxMiddleware";
import thunk from "redux-thunk";
import socketMiddleware from "./middlewares/socketMiddleware.js";
import socket from "./socketClient";

export default function initializeStore(initialState = {}) {
  const composeEnhancers =
    (typeof window !== "undefined" &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;

  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(
      applyMiddleware(axiosReduxMiddleware, socketMiddleware(socket), thunk),
    ),
  );
  store.subscribe(() => {});

  return store;
}
